<template>
  <v-dialog
      :value="value"
      max-width="480"
      persistent
      content-class="simia-welcome-dialog"
      @input="$emit('input', $event)"
  >
    <v-card class="simia-welcome">
      <v-card-text class="simia-welcome__body">
        <h3 class="simia-welcome__title">به «رو‌ب‌رو» خوش اومدی 🌿</h3>
        <p class="simia-welcome__desc">
          اینجا با چند سؤال کوتاه، مناسب‌ترین روان‌درمانگر بهت معرفی می‌شه و می‌تونی جلسه‌ت رو هم رزرو کنی.
        </p>
        <v-btn
            block
            color="#39C990"
            elevation="0"
            class="simia-welcome__btn white--text"
            @click="close"
        >
          شروع کن
        </v-btn>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
const SIMIA_WELCOME_SHOWN_KEY = 'simia_welcome_shown'

export function isFromSimiaQuery(route) {
  const from = route && route.query && route.query.from
  const val = Array.isArray(from) ? from[0] : from
  return String(val || '').toLowerCase() === 'simia'
}

export function shouldShowSimiaWelcome(route) {
  if (!isFromSimiaQuery(route)) return false
  return sessionStorage.getItem(SIMIA_WELCOME_SHOWN_KEY) !== '1'
}

export function markSimiaWelcomeShown() {
  sessionStorage.setItem(SIMIA_WELCOME_SHOWN_KEY, '1')
}

export default {
  name: 'SimiaWelcomeModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      markSimiaWelcomeShown()
      this.$emit('input', false)
    },
  },
}
</script>

<style scoped>
.simia-welcome-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.simia-welcome {
  border-radius: 16px;
  overflow: hidden;
}

.simia-welcome__body {
  padding: 32px 28px 28px !important;
  direction: rtl;
  text-align: center;
}

.simia-welcome__icon {
  font-size: 40px;
  line-height: 1;
  margin-bottom: 12px;
}

.simia-welcome__title {
  margin: 0 0 16px;
  color: #212121;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.5;
}

.simia-welcome__desc {
  margin: 0 0 28px;
  color: #616161;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.8;
}

.simia-welcome__btn {
  height: 48px !important;
  border-radius: 10px !important;
  font-size: 16px !important;
  font-weight: 700 !important;
}
</style>
